import { Typography, Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { useI18n } from "react-simple-i18n";

import { Layout } from "../components/layout/layout";
import { GlobalSpacing } from "../components/layout/styles";

const Privacy = () => {
	const { t } = useI18n()

	return (
		<Layout>
			<GlobalSpacing>
				<PrivacyWrapper>
					<Typography variant="h1" sx={{ mb: 4 }}>
						{t('signup.policy')}
					</Typography>

					<Section>
						<Typography variant="h2">
							{t('privacy.section1.title')}
						</Typography>
						<Typography variant="body1">
							{t('privacy.section1.content')}
						</Typography>
					</Section>

					<Section>
						<Typography variant="h2">
							{t('privacy.section2.title')}
						</Typography>
						<List>
							{[1, 2, 3, 4, 5].map((num) => (
								<ListItem key={num}>
									<Typography variant="body1">
										{t(`privacy.section2.item${num}`)}
									</Typography>
								</ListItem>
							))}
						</List>
					</Section>

					<Section>
						<Typography variant="h2">
							{t('privacy.section3.title')}
						</Typography>
						<Typography variant="body1">
							{t('privacy.section3.content')}
						</Typography>
					</Section>

					<Section>
						<Typography variant="h2">
							{t('privacy.section4.title')}
						</Typography>
						<Typography variant="body1">
							{t('privacy.section4.content')}
						</Typography>
					</Section>

					<UpdatedDate>
						<Typography variant="body2">
							{t('privacy.lastUpdated')}: 2025-03-20
						</Typography>
					</UpdatedDate>
				</PrivacyWrapper>
			</GlobalSpacing>
		</Layout>
	)
}

const PrivacyWrapper = styled(Box)(({ theme }) => ({
	padding: theme.spacing(4, 0),

	'h1': {
		fontWeight: 600,
		color: theme.palette.common.firstColor,
	},

	'h2': {
		fontWeight: 500,
		color: theme.palette.common.firstColor,
		marginBottom: theme.spacing(2),
	},

	[theme.breakpoints.down('md')]: {
		padding: theme.spacing(3, 0),
	}
}))

const Section = styled(Box)(({ theme }) => ({
	marginBottom: theme.spacing(4),

	'& p': {
		color: alpha(theme.palette.common.firstColor, 0.8),
		lineHeight: 1.6,
	}
}))

const List = styled(Box)(({ theme }) => ({
	marginTop: theme.spacing(2),
}))

const ListItem = styled(Box)(({ theme }) => ({
	marginBottom: theme.spacing(1),
	paddingLeft: theme.spacing(2),
	position: 'relative',

	'&:before': {
		content: '""',
		position: 'absolute',
		left: 0,
		top: '0.6em',
		width: '6px',
		height: '6px',
		borderRadius: '50%',
		backgroundColor: theme.palette.common.thirdColor,
	}
}))

const UpdatedDate = styled(Box)(({ theme }) => ({
	marginTop: theme.spacing(6),
	paddingTop: theme.spacing(2),
	borderTop: `1px solid ${theme.palette.divider}`,

	'& p': {
		color: theme.palette.text.secondary,
	}
}))

export { Privacy }